import { useCioPlpContext } from './useCioPlpContext';
export default function useRequestConfigs() {
    const context = useCioPlpContext();
    if (!context) {
        throw new Error('This Hook needs to be called within the Constructor PLP Context Provider.');
    }
    const { urlHelpers, staticRequestConfigs } = context;
    const { getUrl, setUrl, getStateFromUrl, getUrlFromState } = urlHelpers;
    const getRequestConfigs = () => {
        const url = getUrl();
        const urlRequestConfigs = url ? getStateFromUrl(url) : {};
        const page = urlRequestConfigs?.page || staticRequestConfigs?.page || 1;
        const requestConfigs = { ...staticRequestConfigs, ...urlRequestConfigs, page };
        if (!requestConfigs.filterValue || requestConfigs.filterValue === '') {
            delete requestConfigs.filterName;
            delete requestConfigs.filterValue;
        }
        return requestConfigs;
    };
    const setRequestConfigs = (configsToUpdate) => {
        const oldUrl = getUrl();
        if (!oldUrl) {
            throw new Error('getUrl returns undefined when attempting to call setRequestConfigs');
        }
        const oldRequestConfigs = oldUrl ? getStateFromUrl(oldUrl) : {};
        const newRequestConfigs = { ...oldRequestConfigs, ...configsToUpdate };
        const newUrl = getUrlFromState(newRequestConfigs, oldUrl);
        setUrl(newUrl);
    };
    return { getRequestConfigs, setRequestConfigs };
}
